export default __webpack_public_path__ + "static/media/agree.902db57f.png";